export const PATTERN_ONLY_NUMBER = /^(-|\+)?(0*)?([0-9]+)(\.[0-9]+)?$/;

const getSignIfHyphen = (sign?: string) => {
  if (sign === '-') {
    return sign;
  }
  return '';
};

export const removeLeadingZeroIfNeeded = (numberString: string): string => {
  if (typeof numberString !== 'string' || numberString === '') {
    return numberString;
  }
  const matches = numberString.match(PATTERN_ONLY_NUMBER);
  if (matches == null) {
    return numberString;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_matchStr, plusMinus, _zeroPadding, integer, float] = matches;
  const value = `${getSignIfHyphen(plusMinus)}${integer}${float ?? ''}`;
  return value === '-0' ? '0' : value;
};
